export default {
    saveSettings (settings) {
        return window.axios.post("/api/settings", settings);
    },

    loadSettings() {
        return window.axios.get('/api/settings');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/SystemSettingsService.js